import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationStackMigrateVendorArgs, Stack } from "types/generated";

type FetchStackMigrateVendorData = {
  stackMigrateVendor: Pick<Stack, "id" | "vendorConfig" | "labels" | "wasMigratedFromTerraform">;
};

export const MIGRATE_STACK_VENDOR: TypedDocumentNode<
  FetchStackMigrateVendorData,
  MutationStackMigrateVendorArgs
> = gql`
  mutation MigrateStackVendor(
    $id: ID!
    $targetVendor: StackVendor!
    $config: StackVendorMigrationInput
  ) {
    stackMigrateVendor(id: $id, targetVendor: $targetVendor, config: $config) {
      id
      vendorConfig {
        __typename
      }
      labels
      wasMigratedFromTerraform
    }
  }
`;
